import { render } from "./right-bar.vue?vue&type=template&id=4beadab6"
import script from "./right-bar.vue?vue&type=script&lang=js"
export * from "./right-bar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__